import { NgModule } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { UserModule } from '../user/user.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LayoutModule } from '../layouts/layout.module';
import { WorksheetListComponent } from './components/worksheet-list/worksheet-list.component';
import { WorksheetItemComponent } from './components/worksheet-item/worksheet-item.component';
import { ClubModule } from '../club/club.module';
import { StreamAMGPlayerComponent } from 'src/app/shared/components/providers/steamAMG/stream-amg-player/stream-amg-player.component';
import { MediaPlayerModule } from 'src/app/shared/components/media/media-player.module';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
@NgModule({
  declarations: [WorksheetListComponent, WorksheetItemComponent],
  exports: [WorksheetListComponent, WorksheetItemComponent],
  imports: [
    ClubModule,
    RouterModule,
    NgbModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CarouselModule,
    BrowserAnimationsModule,
    SharedModule,
    InlineSVGModule.forRoot(),
    UserModule,
    LayoutModule,
    FGBSharedModule,
    StreamAMGPlayerComponent,
    MediaPlayerModule,
    LoadingModule,
  ],
})
export class LoyaltyModule {}
